module.exports = __webpack_public_path__ + "img/hero-newidea.e4830e72.jpg";